var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report', {
    attrs: {
      "renderBackAndForthFooter": false,
      "isProgressDone": true,
      "showFooter": false
    }
  }, [_c('LoginCard', {
    attrs: {
      "onLogin": _vm.onLoginFunction,
      "logo": _vm.setLogo,
      "title": _vm.title,
      "text": _vm.text,
      "isDescriptionCardActive": true
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }